module.exports = __webpack_public_path__ + "static/media/DecUploadBrowse.af746fde.tsx";